module.exports = __webpack_public_path__ + "img/Combo Hamburguesa.2e1a1198.jpeg";